<div #bar class="bar">
  <!-- Buttons to the left of the message input -->
  <div class="box1 relative">
    <div class="attach-button">
      <!-- The same button is used here so that the ripple is persisted when switching between modes -->
      <button
        [id]="isRecording || hasRecording ? null : 'attach-files'"
        mat-icon-button
        class="celo-hoverable"
        (click)="
          isRecording || hasRecording ? onAudioPlaybackDelete() : attachButton()
        "
        [matTooltip]="isRecording || hasRecording ? 'Delete' : 'Attach'"
        [disabled]="
          isRecording || hasRecording ? false : quotedMessage ? true : false
        "
      >
        @if (!isRecording && !hasRecording) {
          <mat-icon svgIcon="icon-attach"></mat-icon>
        } @else {
          <mat-icon>delete</mat-icon>
        }
      </button>
    </div>

    <div class="attach-button" [hidden]="isRecording || hasRecording">
      <button
        id="attach-secure-library"
        aria-label="Secure Library"
        mat-icon-button
        class="celo-hoverable"
        (click)="addPhotos.emit(); secureLibraryButton()"
        matTooltip="Secure Library"
        [disabled]="quotedMessage ? true : false"
        [disableRipple]="true"
      >
        <mat-icon svgIcon="icon-secure-library"></mat-icon>
      </button>
    </div>
    <div class="attach-button" [hidden]="isRecording || hasRecording">
      <button
        id="attach-upload-photo"
        mat-icon-button
        class="celo-hoverable"
        (click)="photoSelect.click(); uploadButton()"
        matTooltip="Upload Photos and Videos"
        [disabled]="quotedMessage ? true : false"
      >
        <mat-icon svgIcon="icon-photo"></mat-icon>
      </button>
      <input
        [multiple]="true"
        accept="image/png, image/jpeg, video/mp4, video/quicktime"
        #photoSelect
        class="d-none"
        type="file"
        id="celo-textbar"
        celoFileSelect
        [uploader]="uploader"
      />
    </div>

    <div
      class="attach-button emoji-container"
      [hidden]="isRecording || hasRecording"
    >
      <emoji-mart
        [style]="{
          position: 'absolute',
          bottom: bar.offsetHeight + 10 + 'px',
          left: '10px',
        }"
        [class.hidden]="!emojiOpen"
        [darkMode]="false"
        (emojiClick)="addEmoji($event)"
        [showPreview]="false"
        [isNative]="true"
        [emojiTooltip]="true"
      ></emoji-mart>

      <button
        id="emoji-button"
        mat-icon-button
        class="celo-hoverable"
        (click)="emojiOpen = !emojiOpen; emojiOpen ? emojiButton() : ''"
      >
        <mat-icon>{{
          emojiOpen ? "arrow_drop_down" : "sentiment_satisfied_alt"
        }}</mat-icon>
      </button>
    </div>
  </div>

  <!-- Message input -->
  <div
    class="chat-area box"
    [class.invalid]="!isValid"
    [class.audio]="isRecording || hasRecording"
  >
    <div
      class="quote-container open-slow"
      [style.height.px]="quotedMessage ? 80 : 0"
    >
      <div #quote class="quote">
        @if (quotedMessage) {
          <div class="quote-content">
            <app-quoted-message
              [message]="quotedMessage"
              [userAccount]="userAccount"
              [participantAccount]="pMap[quotedMessage.sentBy]"
              [collapsible]="true"
            ></app-quoted-message>
          </div>
        }
      </div>
      <div class="close-button">
        <button
          mat-icon-button
          aria-label="Cancel reply"
          (click)="cancelQuote.emit()"
          disableRipple
        >
          <mat-icon>cancel</mat-icon>
        </button>
      </div>
    </div>

    <!-- Text message input -->
    <app-message-compose-v2
      [hidden]="isRecording || hasRecording"
      #messageCompose
      [initialValue]="initialValue"
      [userId]="userAccount.userId"
      [participants]="participants"
      [maxLength]="maxLength"
      (submitEvent)="handleSubmit($event)"
      (changeEvent)="handleChange($event)"
      (pasteEvent)="handlePaste($event)"
      (userInputEvent)="handleUserInput()"
      (validationEvent)="handleValidationError($event)"
    ></app-message-compose-v2>

    <!-- Recording UI -->
    <div
      class="recording-container"
      [hidden]="!isRecording && !hasRecording"
      (click)="onAudioPlaybackBarClick($event)"
      [class.recording]="isRecording"
      matRipple
      [matRippleDisabled]="!isRecording"
    >
      <app-audio-playback-bar></app-audio-playback-bar>
    </div>
  </div>

  <!-- Record and submit button -->
  <div class="send">
    <button
      mat-icon-button
      (click)="recordAudio()"
      matTooltip="Record"
      [hidden]="isRecording || hasRecording"
      disableRipple
    >
      <mat-icon>mic</mat-icon>
    </button>
    <button
      mat-icon-button
      aria-label="Send message"
      (click)="
        isRecording || hasRecording
          ? sendAudioRecording()
          : messageCompose.submit()
      "
      [disabled]="!isValid"
    >
      <mat-icon>send</mat-icon>
    </button>
  </div>
</div>
